const REQUIRED_PARAMS = [
  "clientId",
  "tierId",
  "subsId",
];

export async function checkAndRedirectIfParamsMissing(): Promise<void> {
  const currentPath = window.location.pathname;
  const allowedPaths = ["/checkout", "/", ""]; 
  if (!allowedPaths.includes(currentPath)) return;

  const currentUrl = new URL(window.location.href);
  const missing = REQUIRED_PARAMS.some(
    (key) => !currentUrl.searchParams.get(key)
  );
  if (!missing) return;

  try {
    const hostname = window.location.hostname;
    const res = await fetch(
      `${process.env.REACT_APP_API_URL_V2}/client/get-domain?url=${hostname}`
    );
    const data = await res.json();
    if (data?.domain) {
      const url = new URL(
        data?.domain.includes("://") ? data?.domain : `https://${data?.domain}`
      );
      window.location.href = `${url.origin}/${data.pathURL}?clientId=${data.clientId}`;
    } else {
      console.error("Unable to continue. Required data is missing.");
    }
  } catch (error) {
    console.error("Resolve error:", error);
  }
}
